<template>
  <div class="header-nav">

    <router-link class="button header-nav__reports" :to="{name: 'reports'}">
      <span class="u-screen-reader-only">Reports</span>
      <PageIcon />
    </router-link>

    <button @click="toggleNav" type="button" class="header-nav__toggle button" :class="{'is-open': !navHidden}">
      <span class="u-screen-reader-only">Settings</span>
      <GearIcon />
    </button>

    <nav class="header-nav__list" name="Settings" :aria-hidden="navHidden">
      <router-link
        v-for="l in links"
        :key="l.to"
        :to="l.to"
        class="header-nav__link"
      >
        {{ l.name }}
      </router-link>
    </nav>
  </div>
</template>

<script>
import GearIcon from 'bootstrap-icons/icons/gear-wide-connected.svg'
import PageIcon from 'bootstrap-icons/icons/file-earmark-ruled.svg'

export default {
  name: 'HeaderNav',

  components: {
    GearIcon,
    PageIcon
  },

  data () {
    return {
      isOpen: false,

      links: [
        {
          to: '/settings/subjects',
          name: 'Subjects'
        },
        {
          to: '/settings/presets',
          name: 'Presets'
        },
        {
          to: '/settings/students',
          name: 'Students'
        }
      ]
    }
  },

  computed: {
    navHidden () {
      return this.isOpen ? null : 'true'
    }
  },

  methods: {
    toggleNav () {
      this.isOpen = !this.isOpen
    }
  },

  watch: {
    $route (to, from) {
      if (to !== from) {
        this.isOpen = false
      }
    }
  }
}
</script>

<style lang="scss">
.header-nav {
  position: relative;

  .button {
    margin-left: .125rem;
  }
}

.header-nav__list {
  padding: .5rem 1rem;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 5;
  transition: opacity .1s, transform .2s ease-in-out;
  transform-origin: right top;
  background-color: #FFF;
  border-radius: 1rem 0 1rem 1rem;

  &[aria-hidden="true"] {
    opacity: 0;
    transform: translateY(-1rem) scale(0);
    visibility: hidden;
  }
}

.header-nav__reports {
  --button-width: 2rem;
  --button-height: 2rem;
}

.header-nav__toggle {
  --button-width: 2rem;
  --button-height: 2rem;

  &.is-open {
    background-color: #FFF;
    border-radius: 1rem 1rem 0 0;
  }
}

.header-nav__link {
  text-decoration: none;

  & + & {
    margin-top: .5rem;
  }
}
</style>
